import Common from '../../wp-controlers/common-panel/geralAttributes';

export default {
  background: {
    type: 'string',
    default: 'white',
  },
  small: {
    type: 'boolean',
    default: false,
  },
  padding: {
    type: 'string',
    default: 'none',
  },
  hasId: {
    type: 'boolean',
    default: false,
  },
  idContainer: {
    type: 'string',
    default: '',
  },
  isFlex: {
    type: 'boolean',
    default: false,
  },
  zIndexUp: {
    type: 'boolean',
    default: false,
  },
  ...Common,
};
